import { Component, Input } from '@angular/core';
import { VmConnectionTemplateDetail } from '../../../../interfaces/vm-connection-templates/vm-connection-template.interface';

/**
 * Read-only presentational summary of a VM Connection Template — protocol + the five Allow*
 * flags rendered as an icon list. Used inside the standalone management page details drawer,
 * the class VM Template attach drawer, and the org-template card attach drawer so all three
 * surfaces stay byte-for-byte identical in look and feel.
 *
 * Stateless — accepts a fully-loaded {@link VmConnectionTemplateDetail} via the
 * `detail` input. Loading and error states are owned by the host component.
 */
@Component({
  selector: 'app-view-vm-connection-template-details',
  templateUrl: './view-vm-connection-template-details.component.html',
  styleUrls: ['./view-vm-connection-template-details.component.css'],
})
export class ViewVmConnectionTemplateDetailsComponent {
  /** Fully-loaded template detail, or `null` while the host is still fetching. */
  @Input() detail: VmConnectionTemplateDetail | null = null;

  /**
   * Returns a Material icon name for a boolean Allow* flag — `check_circle` when the
   * capability is permitted, `cancel` when it is denied. Keeps the template free of
   * nested ternaries.
   */
  iconFor(allowed: boolean): string {
    return allowed ? 'check_circle' : 'cancel';
  }
}
